import { memo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { TableItemId } from "../../../../components/tables/TableWidget";
import CustomButton from "../../../../components/CustomButton";
import { TableItemType } from "../../../../components/tables/tableContext/TableContext";
import {
  getGenerateBarcodeNodeDetails,
  getGenerateBorderouNodeDetails,
  getPreviewBorderou,
} from "../../../../redux/api/expedition.api";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { expeditionRoutes } from "../../../../router/routesConstants";
import ActionMenu from "../../../../components/actionMenu/ActionMenu";
import ModalWrapper from "../../../../components/Modal/ModalWrapper";
import CustomListItem from "../../../../components/misc/CustomListItem";

function NodesRouteTableActionButtons({
  itemId,
  crudData,
}: {
  itemId: TableItemId;
  tableItemData: TableItemType[];
  crudData?: any;
  tableContext?: any;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const {
    general: {
      printers: { data: printerList = [] },
    },
  } = useAppSelector((state) => ({
    general: state.general,
  }));

  const [showModal, setShowModal] = useState(false);
  const [selectedPrinter, setSelectedPrinter] = useState<string | null>(null);

  const generateBarcode = () => {
    dispatch(getGenerateBarcodeNodeDetails({ idNode: itemId }));
  };

  const generateBorderou = () => {
    const selectedPrinterData = printerList.find(
      (printer) => printer.ip_printer === selectedPrinter,
    );
    dispatch(
      getGenerateBorderouNodeDetails({
        nodeName: crudData.nodNume,
        ...selectedPrinterData,
      }),
    );
  };

  const handleEditNod = () => {
    navigate(
      `/${expeditionRoutes.editNodesRoutes}?driver=${crudData.sofer}&car=${crudData.auto}&nodId=${itemId}`,
    );
    return;
  };

  const normalPrinters = printerList.filter(
    (printer) => printer.tip_printer === 1,
  );

  return (
    <>
      <ModalWrapper
        show={showModal}
        handleClose={() => {
          setShowModal(false);
        }}
        modalSize="sm"
        title={`Genereaza borderou pentru nodul ${crudData.nodNume}`}>
        <div className="list-group">
          {normalPrinters.map((printer) => (
            <CustomListItem
              key={printer.ip_printer}
              id={printer.ip_printer}
              name={printer.nume_printer}
              description={`${printer.ip_printer} - ${printer.ip_port}`}
              withIcon
              iconName="/media/icons/duotune/layouts/lay006.svg"
              iconColor="primary"
              onClick={() => setSelectedPrinter(printer.ip_printer)}
              backgroundColor={
                selectedPrinter === printer.ip_printer ? "success" : "info"
              }
            />
          ))}
        </div>
        <div className="flex flex-row justify-between mt-3">
          <CustomButton
            variant="contained"
            className="mx-1 mb-1"
            onClick={() => getPreviewBorderou(crudData.nodNume)}>
            Preview
          </CustomButton>
          <CustomButton
            variant="contained"
            className="mx-1 mb-1"
            disabled={selectedPrinter === null}
            onClick={generateBorderou}>
            Genereaza
          </CustomButton>
        </div>
      </ModalWrapper>
      <ActionMenu
        minItemsForMenu={2}
        title={crudData.nodNume}
        ariaLabel={`Actiuni pentru nodul ${crudData.nodNume}`}
        items={[
          {
            id: "edit",
            label: "Editeaza sofer/masina",
            icon: "EDIT",
            tooltip: "Modifica soferul si masina asociate nodului.",
            onClick: handleEditNod,
          },
          {
            id: "generate-label",
            dividerBefore: true,
            label: "Genereaza eticheta",
            icon: "LABEL",
            kind: "print",
            tooltip: "Genereaza si trimite eticheta nodului la imprimanta.",
            withConfirmationModal: {
              modalTitle: `Genereaza eticheta pentru nodul ${crudData.nodNume}`,
              modalLeftButtonColor: "inherit",
              modalRightButtonOnClick: generateBarcode,
            },
          },
          {
            id: "generate-borderou",
            label: "Genereaza borderou",
            icon: "SUMMARIZE",
            kind: "print",
            tooltip:
              "Alege imprimanta pentru generarea si tiparirea borderoului nodului.",
            onClick: () => setShowModal(true),
          },
        ]}
      />
    </>
  );
}

export default memo(NodesRouteTableActionButtons);
